import { fromJS } from 'immutable'
import {
  USER_UPLOAD_IMAGE_REQUEST,
  USER_UPLOAD_IMAGE_SUCCESS,
  USER_UPLOAD_IMAGE_FAILURE,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_UPLOAD_IMAGE_REQUEST:
      return state
        .set('isFetching', true)
    case USER_UPLOAD_IMAGE_SUCCESS:
      return state
        .set('isFetching', false)
    case USER_UPLOAD_IMAGE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('errorMessage', '')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-upload-image-reducer.js